export default __webpack_public_path__ + "static/media/G0001.e6074448.png";